// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2FpiB","icon":"SortAdornment_icon__3lWao","up":"SortAdornment_up__JOHtv","down":"SortAdornment_down__3tVIo","active":"SortAdornment_active__1MBQP"};